import {
  Button,
  ButtonContainer,
  Card,
  Fieldset,
  FormHeading,
  Heading,
  Layout,
  Paragraph,
  UnorderedList,
} from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { DocumentUpload } from '../../../components/DocumentUpload/DocumentUpload';
import { useNavigate } from '../../../services/routing';
import { newQuotationSliceActions } from '../newQuotation.slice';
import { DocumentFileTypeEnum } from './DocumentUploadPage.model';
import { documentUploadPageSelectors } from './DocumentUploadPage.slice';
import './style.scss';

const requiredFileTypes = ['proofOfId', 'proofOfAddress', 'proofOfPPSN'];

export const DocumentUploadPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [areAllFileTypesUploaded, setAreAllFileTypesUploaded] = useState(false);
  const uploadedFiles = useSelector(documentUploadPageSelectors.uploadedFiles);

  useEffect(() => {
    const types = uploadedFiles.map((file) => (file.metadata?.type as string) || '');
    setAreAllFileTypesUploaded(requiredFileTypes.every((type) => types.includes(type)));
  }, [uploadedFiles]);

  const isFileOfTypeUploaded = (type: DocumentFileTypeEnum): boolean => {
    if (uploadedFiles) {
      return uploadedFiles.some((file) => file.metadata?.type === type);
    }

    return false;
  };

  return (
    <>
      <Card title="">
        <Fieldset>
          <Fieldset.Row>
            <FormHeading>{t('documentUploadPage:title')}</FormHeading>
          </Fieldset.Row>
          <Fieldset.Row>
            <Heading level={6} className="u-text-left">
              {t('documentUploadPage:subtitle')}
            </Heading>
          </Fieldset.Row>
          <Fieldset.Row>
            <Paragraph className="u-text-left">{t('documentUploadPage:description')}</Paragraph>
            <UnorderedList>
              {requiredFileTypes.map((documentType) => (
                <UnorderedList.Item
                  key={documentType}
                  className={`u-text-left ${
                    isFileOfTypeUploaded(DocumentFileTypeEnum[documentType]) ? 'strike-through' : ''
                  }`}
                >
                  {t(`documentUploadPage:documentType.${documentType}`)}
                </UnorderedList.Item>
              ))}
            </UnorderedList>
          </Fieldset.Row>
          <Fieldset.Row>
            <DocumentUpload
              description={t('documentUploadPage:documentUpload.description')}
              supplementaryText={t('documentUploadPage:documentUpload.supplementaryText')}
              uploadButtonText={t('documentUploadPage:documentUpload.uploadButtonText')}
              uploadItemsLabel={t('documentUploadPage:documentUpload.uploadItemsLabel')}
              accept={['.jpg', '.jpeg', '.pdf']}
            />
          </Fieldset.Row>
        </Fieldset>
      </Card>
      <Layout center className="u-mt">
        <ButtonContainer center>
          <Layout.Item default="1/4">
            <Button
              testId="button_goBack"
              secondary
              full
              onClick={() => {
                dispatch(newQuotationSliceActions.wizardPrevPage());
              }}
            >
              {t('usedCarFormSelectorPage:navigation.back')}
            </Button>
          </Layout.Item>

          <Layout.Item default="1/4">
            <Button
              testId="button_continue"
              full
              disabled={!areAllFileTypesUploaded}
              onClick={() => {
                navigate.dealerSummaryPage();
              }}
            >
              {t('usedCarFormSelectorPage:navigation.continue')}
            </Button>
          </Layout.Item>
        </ButtonContainer>
      </Layout>
    </>
  );
};
